"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTime = exports.optionalNullableString = exports.nullableString = exports.optionalEmail = exports.optionalString = exports.requiredString = exports.nonEmpty = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Api.OpenApi.Field';
/*
 * Struct fields for legacy contracts. The description goes on the inner
 * schema as well: on an optional field OpenAPI reads it from there, and
 * `format` is always read from the inner schema.
 *
 * `dateTime` is the string with `format: date-time`. It is not `Entity.CreatedAt`:
 * that schema has a fixed title and description, which a field such as
 * `expiresAt` cannot use.
 */
const nonEmpty = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString.annotations({ description })).annotations({ description });
exports.nonEmpty = nonEmpty;
const requiredString = (description) => effect_1.Schema.propertySignature(effect_1.Schema.String.annotations({ description })).annotations({ description });
exports.requiredString = requiredString;
const optionalString = (description) => effect_1.Schema.optionalWith(effect_1.Schema.String.annotations({ description }), { exact: true }).annotations({
    description,
});
exports.optionalString = optionalString;
const optionalEmail = (description) => effect_1.Schema.optionalWith(effect_1.Schema.String.annotations({
    description,
    jsonSchema: { type: 'string', format: 'email' },
}), { exact: true }).annotations({ description });
exports.optionalEmail = optionalEmail;
const nullableString = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String).annotations({ description })).annotations({ description });
exports.nullableString = nullableString;
const optionalNullableString = (description) => effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String).annotations({ description }), { exact: true }).annotations({
    description,
});
exports.optionalNullableString = optionalNullableString;
const dateTime = (description) => effect_1.Schema.String.annotations({
    description,
    jsonSchema: { type: 'string', format: 'date-time' },
});
exports.dateTime = dateTime;
//# sourceMappingURL=field.js.map